import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const DownloadApp = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => <svg ref={ref} fill="none" viewBox="0 0 25 26" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_509_555)">
      <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17.499 13h4.5a.75.75 0 01.75.75v6.002a.75.75 0 01-.75.75H3.996a.75.75 0 01-.75-.75V13.75a.75.75 0 01.75-.75h4.501m4.501-9.751v9.752" />
      <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8.498 8.5l4.5 4.5L17.5 8.5" />
      <path fill="#fff" d="M18.624 17.876a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z" />
    </g>
    <defs>
      <clipPath id="clip0_509_555">
        <path fill="#fff" d="M0 0h24.004v24.004H0z" transform="translate(.996 .998)" />
      </clipPath>
    </defs>
  </svg>);
export default DownloadApp;